module.exports = __webpack_public_path__ + "img/laptop.30492a.svg";